export default __webpack_public_path__ + "static/media/Vacay-details.90725620.png";